module.exports = __webpack_public_path__ + "img/express_empty.1b48229a.png";